import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const session_id = params.get("session_id");
    if (!session_id) { nav("/"); return; }
    (async () => {
      try {
        await axios.post(`${API}/auth/session`, { session_id });
        await refresh();
        // Clean hash
        window.history.replaceState({}, "", "/account");
        nav("/account", { replace: true });
      } catch (e) {
        nav("/account?err=1", { replace: true });
      }
    })();
    // Intentionally runs once — `processed.current` guards against StrictMode double-invoke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center label-mono text-[var(--text-secondary)]" data-testid="auth-callback">
      Establishing session…
    </div>
  );
}
